import React, { useState } from "react";

const AccordianChip = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      className={`m-3 p-3 w-full md:w-[400px] border-2 ${
        isOpen ? "rounded-3xl " : "rounded-full"
      } `}
    >
      <div className="flex  justify-between items-center  p-1 border-gray-600	">
        <div className="ml-5 font-bold text-left">
          <p>Is registering for a premint sale is safe?</p>
        </div>
        <div>
          <div
            onClick={() => setIsOpen((p) => !p)}
            className="h-12 cursor-pointer w-12 md:h-16 md:w-16 bg-[color:var(--white-color)] 
        text-[color:var(--grey-color)] flex items-center justify-center text-xl md:text-3xl rounded-full"
          >
            {isOpen ? (
              <i class="fa-solid fa-minus"></i>
            ) : (
              <i class="fa-solid fa-plus"></i>
            )}
          </div>
        </div>
      </div>
      <div className={`mt-3 ${isOpen ? "block" : "hidden"}`}>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Obcaecati
          soluta tenetur quis delectus molestiae quos. Eveniet in tenetur
          voluptatibus eaque!
        </p>
      </div>
    </div>
  );
};

const FAQ = () => {
  return (
    <div className="my-20 m-auto text-[color:var(--white-color)]">
      <div className="py-20 px-4 md:px-10 rounded-3xl	 bg-[color:var(--grey-color)]">
        <p className="text-3xl md:text-5xl uppercase font-rubik text-center">
          Frequently
        </p>
        <p className="text-4xl md:text-6xl font-rubik my-4 uppercase font-bold text-center text-[color:var(--yellow-color)]">
          Asked Questions
        </p>
        <p className="text-center">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Dolore id
          ratiolanditiis beatae aliquam incidunt?
        </p>
        <div className="flex flex-wrap mt-5 justify-center items-start">
          <AccordianChip />
          <AccordianChip />
          <AccordianChip />
          <AccordianChip />
          <AccordianChip />
          <AccordianChip />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
